const isLocalFileImage = (media) => media
  && media.localFile
  && media.localFile.childImageSharp
  && media.localFile.childImageSharp.gatsbyImageData !== null;
export default isLocalFileImage;
